import { useController } from 'react-hook-form';
import NumericStepInputBase, {
  NumericStepInputBaseProps,
} from './numeric-step-input-base/numeric-step-input-base.component';

export type NumericStepInputFieldProps = {
  name: string;
  step: number;
} & Partial<NumericStepInputBaseProps>;

const NumericStepInputField = ({
  name,
  step,
  ...rest
}: NumericStepInputFieldProps) => {
  const {
    field: { onChange, value, ref, ...fieldRest },
    fieldState: { error },
  } = useController({
    name,
  });

  return (
    <NumericStepInputBase
      value={value}
      onChange={onChange}
      step={step}
      inputRef={ref}
      error={error}
      {...fieldRest}
      {...rest}
    />
  );
};

export default NumericStepInputField;
